<template>
    <div class="mt-5">
        <div class="row align-items-end mb-5">
            <div class="col-sm-8">
                <b-button class="btn btn-primary rounded p-2 pr-4 pl-4" @click="exportPtfData"><b-icon icon="code-slash" ></b-icon> Download Template</b-button>
            </div>
            <div class="col-sm-4 text-right">
                <a :href="$api_url+'/employee'" class="btn btn-primary rounded p-2 pr-4 pl-4"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to List</span></a>
            </div>
        </div>
        <b-form-group label="Upload the downloaded excel file after the modification.:" label-for="tax-file-upload">
            <b-form-file
            id="tax-file-upload"
            name="datafile"
            @change="uploadFile"
            ref="datafile"
            v-model="empfile"
            :accept="'.xlsx,.xls'"
            :state="validateState('datafile')"
            v-validate="{ mimes: [ 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}"
            aria-describedby="datafile-feedback"
            browse-text="Choose file"
            placeholder="Choose file..."
            ></b-form-file>
            <b-form-invalid-feedback id="datafile-feedback">{{ veeErrors.first('datafile') }}</b-form-invalid-feedback>
        </b-form-group>

        <ul class="list-group mb-3 mt-5" v-if='errormsg'>
            <li class="list-group-item list-group-item-danger" v-for="(data, index) in errormsg" :key="index">{{data}}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: [],
        data() {
            return {
                empfile : null,
                fileErrors: [],
                payrunyears: [],
                year: '',
                showoverlay: false,
                errormsg:[],
            };
        },
        methods: {
            exportPtfData: function()
            {
                if(!this.checkNet()) return false;

                let currentObj = this;
                this.$bvToast.toast('It might take a while', {
                                        title: `Info`,
                                        variant: 'info',
                                        solid: true
                                    });
                this.showoverlay = true;
                let formData = new FormData();

                axios.post(this.$api_url+'/employee/template-cost-center-download', formData)
                    .then(function (response)
                    {
                        this.showoverlay = false;
                        //window.open(response.data);
                        var fileURL = response.data;

                        this.downloadFileContent(fileURL);

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },
            getpayrunyears: function () {
                axios.get('/get/fiscalyear/list').then(function (response) {
                this.payrunyears = response.data;

                }.bind(this));
            },
            uploadFile:function(event)
            {
                if(!this.checkNet()) return false;

                if(event.target.files[0])
                {
                    const file = event.target.files[0];
                    const allowedFileTypes = ['.xlsx', '.xls']; // Add more allowed file types as needed

                    const extension = file.name.substr(file.name.lastIndexOf('.')).toLowerCase();
                    if (allowedFileTypes.includes(extension))
                    {

                    }
                    else
                    {
                        this.$refs.datafile.reset();
                        this.$bvToast.toast('Invalid file type!', {
                            title: `Error`,
                            variant: 'danger',
                            solid: true
                        });
                        return false;
                    }
                }

                let currentObj = this;
                this.showoverlay = true;
                this.errormsg = [];

                this.empfile = event.target.files[0];

                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                const formData = new FormData();
                formData.append('empfile', this.empfile);

                axios.post(this.$api_url + '/upload-cost-center-data-bulk', formData, config)
                    .then(function (response){

                        this.errormsg = response.data.skipped;
                        this.$bvToast.toast('Data feed file successfully imported', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                        this.showoverlay = false;

                    }.bind(this)).
                    catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.$bvToast.toast('Please correct the data and try again. There might be any non well formed data value encountered.' , {
                            title: `Data Template Error`,
                            variant: 'danger',
                            solid: true
                        });
                    });
            },
            submitForm(event) {
                if(!this.checkNet()) return false;
                if(event.target.files[0])
                {
                    const file = event.target.files[0];
                    const allowedFileTypes = ['.xlsx', '.xls']; // Add more allowed file types as needed

                    const extension = file.name.substr(file.name.lastIndexOf('.')).toLowerCase();
                    if (allowedFileTypes.includes(extension))
                    {

                    }
                    else
                    {
                        this.$refs.datafile.reset();
                        // alert('Invalid file type.');
                        this.$bvToast.toast('Invalid file type!', {
                            title: `Error`,
                            variant: 'danger',
                            solid: true
                        });
                        return false;
                    }
                }
                this.fileErrors = [];
                this.errormsg = [];
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay = true;
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    if (this.files.length === 0) {
                        this.fileErrors = ["Please select at least one valid file."];
                        return;
                    }

                    const formData = new FormData();
                    formData.append("fiscal_year", this.year);

                    formData.append("tax_file", this.files);

                    axios.post(this.$api_url + '/upload-tax-files-data-bulk', formData, config)
                    .then(function (response) {
                        this.errormsg = response.data.skipped;

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.showoverlay = false;
                        // this.resetForm();

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);

                        if (error.response && error.response.data && error.response.data.errors) {
                            currentObj.errormsg = error.response.data.errors;
                        } else if (error.message) {
                            currentObj.errormsg = { general: [error.message] };
                        } else {
                            currentObj.errormsg = { general: ['Unexpected error occurred.'] };
                        }
                    });
                });
            },
        },
        created: function () {
            this.getpayrunyears();
        },
    };
</script>
